import React from 'react';

import { Button } from '@makemydeal/dr-ui-bricks-components';
import { PageHeader } from '@makemydeal/dr-sales-checkin-components';

import { ButtonWrapper } from './QuoteRequested.styles';
import { useRequestChangeModal } from '../../hook/useRequestChangeModal';

const QuoteRequested: React.FC = () => {
    const { open: openRequestChangesModal } = useRequestChangeModal();
    return (
        <div data-testid="quote-requested-page">
            <PageHeader
                isResponsive
                heading="We've Received Your Offer"
                description="We're personalizing it now and will send it over shortly."
            />
            <ButtonWrapper>
                <Button
                    data-testid="request-changes-button"
                    width="224px"
                    buttonStyle="secondary"
                    onClick={openRequestChangesModal}
                >
                    Request Changes/Edit Deal
                </Button>
            </ButtonWrapper>
        </div>
    );
};

export default QuoteRequested;
